// "🎓 Eğitim" bölümünün veri-odaklı modül/adım tanımları. Yeni bir modül eklemek için:
// 1) status:'ready' ile bir giriş ekle, steps dizisini yaz (target'lar HER ZAMAN sayfada
//    var olan, veriye bağlı olmayan elemanları hedeflemeli - bos bir hesapta bile
//    calismasi icin tekil kayit/satir/kart hedeflemekten kacinilmali).
// 2) İlgili sayfadaki elemanlara data-tour="..." ekle (görünümü/davranışı değiştirmez).
const trainingModules = [
  {
    key: 'preConsultations',
    label: 'Ön Görüşme',
    icon: '📋',
    route: '/pre-consultations',
    description: 'Gelen ön görüşme/lead taleplerini karşılayın, durumlarını takip edin.',
    status: 'ready',
    steps: [
      {
        target: '[data-tour="pc-header"]',
        title: '📋 Ön Görüşme Talepleri',
        content: 'Bu sayfada WhatsApp, Instagram, telefon veya web üzerinden gelen tüm ön görüşme/lead taleplerini görürsünüz.'
      },
      {
        target: '[data-tour="pc-new-btn"]',
        title: '+ Yeni Talep',
        content: 'Bir talebi elle eklemek isterseniz buraya basın: Ad Soyad, Telefon, Ülke, Kaynak (Telefon/WhatsApp/Instagram/Web/Manuel), Sektör ve Notlar alanlarını doldurup kaydedersiniz.'
      },
      {
        target: '[data-tour="pc-stats"]',
        title: 'Durum Kartları',
        content: 'Toplam, Bekliyor, Arandı, Randevulu, Tamamlandı ve Kayıp kartları — sayıları gösterir, aynı zamanda birer filtredir: birine tıklayınca sadece o durumdaki talepler listelenir.'
      },
      {
        target: '[data-tour="pc-search"]',
        title: 'Arama',
        content: 'İsim veya telefon numarasına göre hızlıca arama yapabilirsiniz.'
      },
      {
        target: '[data-tour="pc-date-filter"]',
        title: 'Tarih Filtresi',
        content: 'Varsayılan olarak bugünün talepleri gösterilir. Bu Hafta, Bu Ay ya da 📅 Tarih Seç ile istediğiniz bir aralığa geçebilirsiniz.'
      },
      {
        target: '[data-tour="pc-view-toggle"]',
        title: 'Görünüm',
        content: '📋 Pipeline görünümü sürükle-bırak ile durum değiştirmenizi sağlar; ☰ Liste görünümü daha sade bir tablo sunar.'
      },
      {
        target: '[data-tour="pc-kanban"]',
        title: 'Talepler ve Detay',
        content: 'Her kart bir talebi temsil eder; kartları sütunlar arasında sürükleyerek durumunu değiştirebilirsiniz. Bir karta tıklayınca detay ekranı açılır — orada 🤖 varsa AI\'nın çıkardığı özeti görür, 📞 Arandı / 📅 Randevulandı / ✓ Tamamlandı / ✕ Kayıp / 🗑️ Sil butonlarıyla işlem yaparsınız.'
      }
    ]
  },
  {
    key: 'messages',
    label: 'Mesajlar',
    icon: '💬',
    route: '/messages',
    description: 'WhatsApp, Instagram ve Messenger sohbetlerini tek yerden yönetin.',
    status: 'ready',
    steps: [
      {
        target: '[data-tour="msg-header"]',
        title: '💬 Sohbetler',
        content: 'Tüm müşteri mesajlaşmalarınızı (WhatsApp, Instagram, Messenger) buradan takip edersiniz. Bağlantı durumunuzu (WA Bağlı / Bağlantı Yok) başlığın yanında görürsünüz.'
      },
      {
        target: '[data-tour="msg-platform-filter"]',
        title: 'Kanal Filtresi',
        content: 'Tümü, WhatsApp, Instagram veya Messenger sekmeleriyle sadece o kanaldaki sohbetleri görebilirsiniz.'
      },
      {
        target: '[data-tour="msg-contact-list"]',
        title: 'Sohbet Listesi',
        content: 'Soldaki listede tüm kişiler görünür; kırmızı rozet okunmamış mesaj sayısını gösterir. Bir kişiye tıklayınca sağda o sohbet açılır.'
      },
      {
        target: '[data-tour="msg-chat-pane"]',
        title: 'Sohbet Penceresi',
        content: 'Bir sohbete tıkladığınızda burada mesaj geçmişi açılır, altta da kendi mesajınızı yazıp gönderebilirsiniz.'
      },
      {
        target: '[data-tour="msg-mode-toggle"]',
        title: '🤖 AI Asistanı Aktif / 👤 Personele Devret',
        content: 'Bu iki buton, o sohbeti kimin yöneteceğini belirler. "AI Asistanı Aktif" seçiliyken müşteriye otomatik olarak yapay zeka cevap verir. Siz kendiniz cevap yazmak isterseniz "Personele Devret"e basın — o andan itibaren AI o sohbete karışmaz, siz devralırsınız. İstediğiniz zaman tekrar "AI Asistanı Aktif"e basıp AI\'ya geri verebilirsiniz.'
      }
    ]
  },
  {
    key: 'customers',
    label: 'Müşteriler',
    icon: '👥',
    route: '/customers',
    description: 'Müşteri kayıtlarını görüntüleyin, arayın ve yenilerini ekleyin.',
    status: 'ready',
    steps: [
      {
        target: '[data-tour="cust-header"]',
        title: '👥 Müşteriler',
        content: 'Kayıtlı tüm müşterileriniz burada listelenir, üstte toplam müşteri sayınızı görürsünüz.'
      },
      {
        target: '[data-tour="cust-new-btn"]',
        title: '+ Yeni Müşteri',
        content: 'Yeni bir müşteri eklemek için buraya basın. Açılan formda Ad ve Telefon zorunludur; ayrıca Soyad, E-posta, Cinsiyet, Doğum Tarihi, Şehir, Kaynak (Gelip Kayıt/Instagram/WhatsApp/Tavsiye/Web/Telefon) ve Not girebilir, dilerseniz kimlik/rapor gibi evrak/belge de yükleyebilirsiniz. Sonunda "Müşteri Ekle"ye basarak kaydedersiniz.'
      },
      {
        target: '[data-tour="cust-search"]',
        title: 'Arama',
        content: 'İsimle hızlıca müşteri arayabilirsiniz.'
      },
      {
        target: '[data-tour="cust-table"]',
        title: 'Müşteri Listesi',
        content: 'Müşteri, İletişim, Kaynak, Sadakat seviyesi ve Son Ziyaret bilgilerini görürsünüz. Bir satırdaki Görüntüle\'ye tıklayınca o müşterinin tüm geçmişini (randevular, ödemeler, notlar) içeren detay sayfasına gidersiniz.'
      }
    ]
  },
  {
    key: 'calendar',
    label: 'Randevular',
    icon: '📅',
    route: '/calendar',
    description: 'Randevuları takvim üzerinde görün, oluşturun ve yönetin.',
    status: 'ready',
    steps: [
      {
        target: '[data-tour="cal-header"]',
        title: '📅 Randevular',
        content: 'Tüm randevularınızı buradan yönetirsiniz. Yeni Randevu ile Müşteri, Hizmet, Personel, Tarih-Saat ve Not girip randevu oluşturursunuz; Saat Kapat ile bir personelin (veya tüm şubenin) belirli bir aralığını (izin, mola vb.) kapatabilirsiniz.'
      },
      {
        target: '[data-tour="cal-toolbar"]',
        title: 'Takvim Araç Çubuğu',
        content: 'Bugün ve ok butonlarıyla tarihte gezinirsiniz; Gün, Hafta, Ay sekmeleriyle görünümü değiştirirsiniz. Personel filtreleme paneli varsa, belirli personelleri gösterip gizleyebilirsiniz.'
      },
      {
        target: '[data-tour="cal-main"]',
        title: 'Randevu Takvimi',
        content: 'Ay görünümünde her güne ait randevu sayısını, Gün/Hafta görünümünde saat saat dolulukları görürsünüz. Boş bir saate tıklayınca o saate randevu oluşturabilirsiniz. Bir randevuya tıkladığınızda durumuna göre Düzenle / Onayla / İşleme Başla / Tamamla / İptal Et işlemlerini yapabileceğiniz detay ekranı açılır.'
      }
    ]
  },

  // --- Yakında eklenecek modüller (sadece kart olarak listelenir) ---
  { key: 'kanban', label: 'Lead Pipeline', icon: '🎯', route: '/kanban', description: 'Fırsatları aşamalara göre takip edin.', status: 'soon' },
  { key: 'callbacks', label: 'Aramalar', icon: '📞', route: '/callbacks', description: 'Geri arama taleplerini yönetin.', status: 'soon' },
  { key: 'notifications', label: 'Bildirimler', icon: '🔔', route: '/notifications', description: 'Sistem bildirimlerinizi görün.', status: 'soon' },
  { key: 'finance', label: 'Finans', icon: '💰', route: '/finance', description: 'Gelir/gider takibi.', status: 'soon' },
  { key: 'automations', label: 'İş Akışları', icon: '⚙️', route: '/automations', description: 'Otomasyon kurallarını yönetin.', status: 'soon' },
  { key: 'pos', label: 'Kasa / POS', icon: '🧾', route: '/pos', description: 'Satış ve tahsilat işlemleri.', status: 'soon' },
  { key: 'products', label: 'Stok', icon: '📦', route: '/products', description: 'Ürün ve stok takibi.', status: 'soon' },
  { key: 'metaAds', label: 'Meta Ads', icon: '📘', route: '/meta-ads', description: 'Facebook/Instagram reklamları.', status: 'soon' },
  { key: 'opportunities', label: 'Gelir Fırsatları', icon: '📈', route: '/opportunities', description: 'Ek satış fırsatlarını takip edin.', status: 'soon' },
  { key: 'settings', label: 'Ayarlar', icon: '🛠️', route: '/settings', description: 'Şube ve sistem ayarları.', status: 'soon' },
  { key: 'staff', label: 'Personel', icon: '🧑‍💼', route: '/staff', description: 'Personel kayıtlarını yönetin.', status: 'soon' },
  { key: 'payroll', label: 'Bordro & Maaş', icon: '💵', route: '/payroll', description: 'Personel maaş/prim takibi.', status: 'soon' },
  { key: 'services', label: 'Hizmetler', icon: '✂️', route: '/services', description: 'Hizmet ve fiyat listesi.', status: 'soon' },
  { key: 'measurements', label: 'Ölçü Kartı', icon: '📏', route: '/measurements', description: 'Müşteri ölçülerini kaydedin.', status: 'soon' },
  { key: 'fitting', label: 'Prova', icon: '👗', route: '/fitting', description: 'Prova randevularını yönetin.', status: 'soon' },
  { key: 'rental', label: 'Kiralama', icon: '🏷️', route: '/rental', description: 'Ürün kiralama takibi.', status: 'soon' },
  { key: 'surveys', label: 'Keşif / Ölçü', icon: '📐', route: '/surveys', description: 'Saha keşif kayıtları.', status: 'soon' },
  { key: 'quotes', label: 'Teklifler', icon: '📄', route: '/quotes', description: 'Müşteri tekliflerini yönetin.', status: 'soon' },
  { key: 'production', label: 'Üretim', icon: '🏭', route: '/production', description: 'Üretim süreçlerini takip edin.', status: 'soon' },
  { key: 'reservations', label: 'Rezervasyon', icon: '🗓️', route: '/reservations', description: 'Rezervasyonları yönetin.', status: 'soon' },
  { key: 'packages', label: 'Paketler', icon: '🎁', route: '/packages', description: 'Paket tekliflerini yönetin.', status: 'soon' },
  { key: 'eventChecklist', label: 'Checklist', icon: '✅', route: '/event-checklist', description: 'Etkinlik kontrol listesi.', status: 'soon' },
  { key: 'weddingVendors', label: 'Tedarikçiler', icon: '🤝', route: '/wedding-vendors', description: 'Tedarikçi kayıtlarını yönetin.', status: 'soon' },
  { key: 'patientTracking', label: 'Hasta Takibi', icon: '🩺', route: '/patient-tracking', description: 'Hasta süreçlerini takip edin.', status: 'soon' },
  { key: 'hotelReservations', label: 'Rezervasyon', icon: '🏨', route: '/hotel-reservations', description: 'Otel rezervasyonlarını yönetin.', status: 'soon' },
  { key: 'dentalTreatments', label: 'Tedavi', icon: '🦷', route: '/dental-treatments', description: 'Tedavi planlarını yönetin.', status: 'soon' },
  { key: 'autoReminders', label: 'Hatırlatma', icon: '⏰', route: '/auto-reminders', description: 'Otomatik hatırlatmaları yönetin.', status: 'soon' },
  { key: 'departments', label: 'Departmanlar', icon: '🏢', route: '/departments', description: 'Departman/doktor listesi.', status: 'soon' },
  { key: 'patientSatisfaction', label: 'Memnuniyet', icon: '⭐', route: '/patient-satisfaction', description: 'Memnuniyet anketlerini yönetin.', status: 'soon' },
  { key: 'ecommerceOrders', label: 'Siparişler', icon: '🛒', route: '/ecommerce-orders', description: 'Siparişleri yönetin.', status: 'soon' },
  { key: 'returnManagement', label: 'İadeler', icon: '↩️', route: '/return-management', description: 'İade taleplerini yönetin.', status: 'soon' }
];

export default trainingModules;
